import React from 'react';
import TransferWorkflowStatus from './TransferWorkflowStatus';
import DropDown from '@/common/DropDown';
import { TransferMacrostatus, TransferSourceEnum, TransferStatusWorkflow } from '../types';
import { useDisclosure } from '@chakra-ui/react';
import { pastTenseFailedStatus, pastTenseStatus, TransferDetailsInitialState, transferMacrostatus, transferStepStatus } from '@/utils/constants';
import { getFormattedDateTime } from './value-formatters/date-formatter.mjs';
import { getTransferDetails } from '../ducks/selectors';
import { getDynamicDuration } from '@/utils/utils';

function TransferLabelDropDown({ step, version }: { step: TransferStatusWorkflow, version: number }) {
  const {
    isOpen: isStatusWorkFlowOpen,
    onOpen: onOpenStatusWorkFLow,
    onClose: onCloseStatusWorkFLow
  } = useDisclosure();
  const transferDetails = getTransferDetails() || TransferDetailsInitialState;
  const fireArmType = transferDetails?.TransferDetails?.products ? transferDetails?.TransferDetails?.products[0] : null  
  return (
    <div className="stepper__step-label">
      {step?.microStatus && step?.microStatus.length > 0? (
        <DropDown
          onOpen={
            step.microStatus && step.microStatus.length > 0
              ? onOpenStatusWorkFLow
              : () => {}
          }
          onClose={onCloseStatusWorkFLow}
          isOpen={isStatusWorkFlowOpen}
          popoverContent={
            <TransferWorkflowStatus 
              transferStatusWorkflow={step.microStatus} 
              stepStatus={step.stepStatus}
              version={version}
            />
          }
          placement="bottom-end"
          variant="transfer-status-workflow"
          noMaxHeight={true}
        >
          <button
            className="transfer-details__workflow_status"
            onClick={
              step.microStatus && step.microStatus.length > 0
                ? onOpenStatusWorkFLow
                : () => {}
            }
          >
            <div
              className={`stepper__dropdown-wrappper ${
                step.stepStatus === transferStepStatus.in_progress
                // ||
                // (step.stepStatus === transferStepStatus.success &&
                //   step.status ===
                //     TransferMacrostatus.outbound_transfer_complete)
                  ? 'stepper__dropdown-active-step'
                  : ''
              } ${
                step.stepStatus === transferStepStatus.failed
                  ? 'stepper__dropdown-failed-step'
                  : ''
              }`}
            >
              <span>{((step.stepStatus === transferStepStatus.success && version === 1)?
                      (pastTenseStatus[step.status] && pastTenseStatus[step.status] || transferMacrostatus[step.status]) :  
                      transferMacrostatus[step.status])}</span>
              {(step.microStatus && step.microStatus.length > 0) ? (
                <img
                  src="/images/ui/down-arrow.svg"
                  className={`${
                    step.stepStatus === transferStepStatus.in_progress
                      ? 'stepper__dropdown-image-active-step'
                      : ''
                  }`}
                />
              ):""}
            </div>
            {((!step.microStatus || step.microStatus.length <= 0) || step.status === TransferMacrostatus.transfer_initiated) && (
              <>
              <div className="stepper__timestamp">
                { 
                  (step?.sourceDescription && (step.status === TransferMacrostatus.transfer_initiated)) ? 
                  <>
                    <p> Initiated by {step.sourceDescription}</p> 
                    <p>
                      As on {' '} {step.stepStatus === transferStepStatus.in_progress ? getFormattedDateTime(step.startedAt) : getFormattedDateTime(step.finishedAt)}
                    </p>
                  </>
                  : ""
                }
                {(transferDetails?.TransferDetails?.createdAt && transferDetails?.TransferDetails?.outboundTransferCompletionTimestamp && step.status === TransferMacrostatus.transfer_initiated) && <p>Duration: {getDynamicDuration(transferDetails?.TransferDetails?.createdAt, transferDetails?.TransferDetails?.outboundTransferCompletionTimestamp)}</p>}
              </div>
              </>
            )}
          </button>
        </DropDown>
      ) : (
        <div
          className={`stepper__dropdown-wrappper stepper__dropdown-inactive-step`}
        >
          <span>{ transferMacrostatus[step.status] }</span>
        </div>
      )}
    </div>
  );
}

export default TransferLabelDropDown;
